

import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import './StyleAssets/blueskyMainStyles.scss';
// import './StyleAssets/indexStyles.scss';
// import './StyleAssets/loginPageStyles.scss';
// import './StyleAssets/portalPageStyles.scss';
// import './StyleAssets/shoppingRegisterPageStyles.scss';
// import './StyleAssets/animate.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toggle-switch/dist/css/switch.min.css";

//import '<link href="https://fonts.googleapis.com/css?family=Roboto&display=swap" rel="stylesheet">';
// import './JsAssets/jquery.min.js';
// import './JsAssets/jquery.nicescroll.min.js';
import IndexPageComponent from './Scenes/IndexPage';

ReactDOM.render(<IndexPageComponent />, document.getElementById('root'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
